/**
 * 🔔 Agent tasdiq kutyapti — brauzer yorlig'i sarlavhasi (va belgisi) miltillaydi (2026-11-02, operator: «boshqa tabda yoki boshqa
 * joyda bo'lsam bilmay qolayapman — tasdiqlamagunimcha title yonib-o'chib tursin»).
 *  · Manba: serverdagi kutilayotgan tasdiqlar (GET /conductor/confirmations/pending) — sahifa ochilganda, socket ulanganda,
 *    `operator:confirmation` / `conductor:decision` kelganda, oyna fokuslanganda va kutish bor ekan har 60 s.
 *    Muddat (30 daq) server `ttl` bilan — o'tib ketgani o'zi tushadi.
 *  · Har oyna (App /, /emu, /db, /m, /emu-view) o'z socket'ida `attachConfirmBlink(socket)` — hodisalar foydalanuvchining
 *    BARCHA socket'lariga boradi, demak barcha ochiq yorliqlar birga miltillaydi va biri tasdiqlansa hammasida to'xtaydi.
 *  · Soat — public/kh-tick.js worker (fon yorlig'ida ham ~1 s); bo'lmasa oddiy setInterval.
 */
const API = process.env.REACT_APP_API_URL ?? '';
const TICK_MS = 1000;
const DEFAULT_TTL_MS = 30 * 60_000;
const ALERT_ICON = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle cx="16" cy="16" r="15" fill="#dc2626"/><text x="16" y="23" font-size="21" font-family="Arial,sans-serif" font-weight="700" text-anchor="middle" fill="#fff">!</text></svg>');

const S = { pending: new Map(), clock: null, on: false, base: null, lastSet: null, icons: null, sockets: new WeakSet(), inited: false, syncTimer: null, poll: null };

// Qayerda: «Idora · 🧭 Dizayn moslashtirish» — karta faqat o'z suhbatida ko'rinadi, loyiha nomi yetmasdi (2026-11-05, Idora #154).
const labelOf = () => {
  const names = [...new Set([...S.pending.values()].map(c => (c.projectName ? c.projectName + (c.threadTitle ? ` · ${c.threadTitle}` : '') : null)).filter(Boolean))];
  const n = S.pending.size;
  return `🔔 ${n > 1 ? `${n} ta tasdiq kerak` : 'Tasdiq kerak'}${names.length ? ` — ${names.join(', ')}` : ''}`;
};

function setIcon(alert) {
  try {
    if (!S.icons) S.icons = [...document.querySelectorAll('link[rel~="icon"]')].map(l => ({ l, href: l.getAttribute('href') }));
    for (const x of S.icons) x.l.setAttribute('href', alert ? ALERT_ICON : x.href);
  } catch (e) { }
}

function tick() {
  const now = Date.now();
  for (const [id, c] of S.pending) if (c.deadline <= now) S.pending.delete(id);
  if (!S.pending.size) { stopClock(); return; }
  // Ilova sarlavhani o'zgartirgan bo'lsa (sahifa/bo'lim almashdi) — yangisi asos bo'ladi.
  if (document.title !== S.lastSet) S.base = document.title;
  S.on = !S.on;
  S.lastSet = S.on ? labelOf() : S.base;
  document.title = S.lastSet;
  setIcon(S.on);
}

function startClock() {
  if (S.clock) return;
  S.base = document.title; S.lastSet = document.title; S.on = false;
  try {
    const w = new Worker('/kh-tick.js');
    w.onmessage = tick;
    w.onerror = () => { try { w.terminate(); } catch (e) { } if (S.clock && S.clock.w === w) { S.clock = { iv: setInterval(tick, TICK_MS) }; } };
    w.postMessage(TICK_MS);
    S.clock = { w };
  } catch (e) { S.clock = { iv: setInterval(tick, TICK_MS) }; }
  tick();
}

function stopClock() {
  const c = S.clock; S.clock = null;
  if (c) { if (c.w) { try { c.w.terminate(); } catch (e) { } } if (c.iv) clearInterval(c.iv); }
  if (S.base != null && document.title === S.lastSet) document.title = S.base;
  S.on = false; S.lastSet = null;
  setIcon(false);
  if (S.poll) { clearInterval(S.poll); S.poll = null; }
}

function apply() {
  if (S.pending.size) {
    startClock();
    if (!S.poll) S.poll = setInterval(sync, 60_000);   // boshqa joyda qaror / muddat — 60 s da tekshirib turamiz
  } else stopClock();
}

/** Serverdan kutilayotgan tasdiqlar (haqiqat manbai). Xato bo'lsa joriy holat qoladi. */
export async function sync() {
  const token = (() => { try { return localStorage.getItem('khorezmai_token') || ''; } catch (e) { return ''; } })();
  if (!token) { S.pending.clear(); apply(); return; }
  try {
    const r = await fetch(`${API}/conductor/confirmations/pending`, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) return;
    const d = await r.json();
    const now = Date.now();
    S.pending = new Map((d.items || []).map(c => [Number(c.id), { projectName: c.projectName || null, threadTitle: c.threadTitle || null, deadline: now + Math.max(0, Number(c.ttl) || 0) * 1000 }]));
    apply();
  } catch (e) { }
}
const syncSoon = (ms = 400) => { clearTimeout(S.syncTimer); S.syncTimer = setTimeout(sync, ms); };

/** Shu sahifaning socket'iga ulash (har socket bir marta). */
export function attachConfirmBlink(socket) {
  if (!socket || S.sockets.has(socket)) return;
  S.sockets.add(socket);
  socket.on('operator:confirmation', (d) => {
    if (!d || !d.id) return;
    if (d.status === 'pending') { S.pending.set(Number(d.id), { projectName: d.projectName || null, deadline: Date.now() + DEFAULT_TTL_MS }); apply(); }
    else { S.pending.delete(Number(d.id)); apply(); }
    syncSoon();
  });
  socket.on('conductor:decision', (d) => { if (d && d.id) { S.pending.delete(Number(d.id)); apply(); } syncSoon(); });
  socket.on('connect', () => syncSoon(200));
  if (!S.inited) {
    S.inited = true;
    const wake = () => { if (document.visibilityState === 'visible') syncSoon(100); };
    document.addEventListener('visibilitychange', wake);
    window.addEventListener('focus', wake);
  }
  syncSoon(100);
}
